import MuiPagination from "@material-ui/lab/Pagination"
import React, { ChangeEvent } from "react"
import styled from "styled-components"

interface IProps {
  count: number
  page: number
  onChange: (event: ChangeEvent<unknown>, value: number) => void
}

const Center = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
`

const StyledPagination = styled(MuiPagination)`
  .MuiPaginationItem-page {
    transition: ${({ theme }) =>
      theme.transitions.create(["background-color", "color"], {
        duration: theme.transitions.duration.short,
        easing: theme.transitions.easing.easeInOut,
      })};
  }
  .MuiPaginationItem-page.Mui-selected {
    background-color: ${({ theme }) => theme.palette.primary.main};
    color: ${({ theme }) => theme.palette.primary.contrastText};
  }
  .MuiPaginationItem-page:hover {
    background-color: ${({ theme }) => theme.palette.primary.dark};
    color: ${({ theme }) => theme.palette.primary.contrastText};
  }

  .MuiPaginationItem-root {
    color: ${({ theme }) => theme.palette.primary.main};
  }

  .MuiPaginationItem-page.Mui-selected:hover,
  .MuiPaginationItem-page.Mui-selected.Mui-focusVisible {
    background-color: ${({ theme }) => theme.palette.primary.main};
  }
`

const Pagination: React.FC<IProps> = ({ count, page, onChange }) =>
  count > 1 ? (
    <Center>
      <StyledPagination
        count={count}
        page={page}
        onChange={onChange}
        shape="rounded"
      />
    </Center>
  ) : null

export default Pagination
